<template>
  <div
    v-if="messages.length"
    class="fixed inset-x-0 bottom-0 z-[9999999] mx-auto mb-size-6 w-(--container-width) space-y-size-6 text-white hover:cursor-pointer"
  >
    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions -->
    <div
      v-for="(message, i) in messages"
      :key="i"
      class="dark:bg-primary-dark flex items-center justify-between rounded bg-primary p-6 font-bold"
      :class="classes[message.type]"
      @click="removeMessage(i)"
    >
      <div v-html="message.message" />
      <SpriteSymbol name="close" class="size-6" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DrupalMessageType } from '~/composables/useDrupalMessages'

const { messages, removeMessage } = useDrupalMessages()

const classes: Record<DrupalMessageType, string> = {
  error: 'bg-error-100 text-error-800',
  warning: 'bg-warning-100 text-warning-800',
  status: 'bg-success-100 text-success-800',
}
</script>
